import { render, staticRenderFns } from "./qr_code_elevator.vue?vue&type=template&id=1c18748f&scoped=true"
import script from "./qr_code_elevator.vue?vue&type=script&lang=js"
export * from "./qr_code_elevator.vue?vue&type=script&lang=js"
import style0 from "./qr_code_elevator.vue?vue&type=style&index=0&id=1c18748f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c18748f",
  null
  
)

export default component.exports